export const RECOM_PROXY_BASE_PATH = '/api/recom';

export const RECOM_USER_DATA_KEY = {
	apiBaseUrl: 'recom_api_base_url',
	storeId: 'recom_store_id',
} as const;

export const RECOM_REQUEST_TIMEOUT_MS = 15_000;

/**
 * Tope de la semilla del carrusel del carrito. El de verdad es config por tienda
 * (`carousels.cart.partnumbers_max`) y pasarlo es un 400 del upstream, así que
 * el cliente recorta a los más recientes con el default documentado.
 */
export const RECOM_CART_PARTNUMBERS_MAX = 20;

export const RECOM_ERROR_CODE = {
	validation: 'VALIDATION_ERROR',
	usersUpstream: 'USERS_UPSTREAM_ERROR',
	usersClient: 'USERS_CLIENT_ERROR',
	recommendationClient: 'RECOMMENDATION_CLIENT_ERROR',
	comboClient: 'COMBO_CLIENT_ERROR',
	notFound: 'NOT_FOUND',
	internal: 'INTERNAL_SERVER_ERROR',
	proxy: 'RECOM_PROXY_ERROR',
	invalidResponse: 'RECOM_INVALID_RESPONSE',
} as const;

export type RecomErrorCode = typeof RECOM_ERROR_CODE[keyof typeof RECOM_ERROR_CODE];
